import { render, staticRenderFns } from "./ValidationAlertByStrings.vue?vue&type=template&id=30a61ef6&scoped=true&lang=pug"
import script from "./ValidationAlertByStrings.vue?vue&type=script&lang=ts"
export * from "./ValidationAlertByStrings.vue?vue&type=script&lang=ts"
import style0 from "./ValidationAlertByStrings.vue?vue&type=style&index=0&id=30a61ef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a61ef6",
  null
  
)

export default component.exports